import { Text } from 'shared/ui/common/Text'
import { WarningCard } from 'shared/ui/common/WarningCard'

export const FormBorrowWarning = () => {
  return (
    <WarningCard
      title="Important note:"
      content={
        <Text color="secondary" weight={400} size={12} isCentered>
          Your must repay your loan within 35 days (30 days till loan is due
          plus 5-days grace period). If you do not repay your loan in time, you
          will no longer be able to borrow from RociFi, your address(es) will be
          ‘doxxed’ on Twitter and your address will be locked out from the
          entire ecosystem that uses NFCS API to serve their users.
        </Text>
      }
    />
  )
}
